import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {Object} from 'es6-shim';
import {TableHeaderItem} from '../../../../commons/components/table-component/domain/table-header-item';
import {IUser} from '../../../../commons/interfaces/user/user';
import {FileService} from '../../../../services/file.service';
import {IListini} from '../../../../commons/interfaces/listini';
import {IRivenditore} from '../../../../commons/interfaces/IRivenditore';

export interface IUserT {
  email: string;
  piva: string;
  codice_fiscale: string;
  company_name: string;
  _id: string;
  subscriptionEnd: string;
  subscriptionEndDate: Date;
  // qui mette true 7gg prima
  expired: boolean;
  nearExpiration: boolean;
  activationCode: string;
  activation: string;
  expiredOrCancelled: boolean;
  useDigitalSign: boolean;
  viewOnly: boolean;
  archisync: boolean;
  archipro: boolean;
  onlyConservazione: boolean;
  isCancellationInProgress: boolean;
  reseller: IRivenditore;
}

class SchedaClientiController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService',
    'FileService',
  ];

  private headerColumns: Array<TableHeaderItem>;

  constructor(
    private $scope: {
      scaduti: IUserT[];
      filtroScadenza: (string | Date | boolean | IListini)[];
      rivenditori: IRivenditore[];
      regexCheckYearToExport: RegExp;
      tooltips: {};
      [key: string]: any
    },
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
    private FileService: FileService,
  ) {
    $scope.entries = Object.entries;
    $scope.pageHeader = 'Scheda Clienti';
    $scope.pageSubHeader = 'Scegli l\'utente';
    $scope.tooltips = {
      'yearToExport': 'Scrivere l\'anno da esportare, è possibile tornare indietro di 5 anni',
    };

    const currentYear = new Date().getFullYear();
    $scope.regexCheckYearToExport = new RegExp(`^(${Array.from({ length: 6 }, (_, i) => currentYear - i).join('|')})$`);

    $scope.scaduti = [];
    let allScaduti = [] as IUserT[];
    $scope.filtroScadenza = [];
    this.headerColumns = [
      {key: 'email', label: 'Email', ratio: '33', isSortable: false},
      {key: 'piva', label: 'P.Iva', ratio: '33', isSortable: false},
      {key: 'subscriptionEnd', label: 'Scadenza', ratio: '33', isSortable: false},
    ];
    $rootScope.formsubmitted = false;

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    ArchiSmallServices.getRivenditori().then(response => {
      $scope.rivenditori = JSON.parse(JSON.stringify(response)) as IListini[];
      $scope.rivenditori.sort((a, b) => a.name.localeCompare(b.name));
    });

    $scope.getUsersTypeaheadValues = () => {
      ArchiSmallServices.getUsers()
        .then((response) => {
          // deep copy
          allScaduti = (JSON.parse(JSON.stringify(response)) as IUser[]).map(item => {
            const newObj = {
              email: item.accountData.email,
              piva: item.organizationData.PIVA,
              codice_fiscale: item.organizationData.fiscalCode,
              company_name: item.organizationData.name ||
                (item.organizationData.contactPerson.firstname + ' ' + item.organizationData.contactPerson.surname),
              _id: item._id,
              subscriptionEnd: new Date(item.subscription.subscriptionEnd).toLocaleDateString(),
              subscriptionEndDate: new Date(item.subscription.subscriptionEnd),
              // qui mette true 7gg prima
              expired: (new Date(item.subscription.subscriptionEnd).getTime() - new Date().getTime()) < 0,
              nearExpiration: (new Date(item.subscription.subscriptionEnd).getTime() - new Date().getTime()) < 604800000 &&
                (new Date(item.subscription.subscriptionEnd).getTime() - new Date().getTime()) > 0,
              activationCode: item.subscription.activationCode,
              activation: new Date(item.subscription.subscriptionStart).toLocaleDateString(),
              // expiredOrCancelled: !item.subscription.subscriptionCancelled && !item.subscription.subscription_expired,
              useDigitalSign: item.useDigitalSign,
              viewOnly: !item.canUseFatturaPA && !item.canUseConservazione,
              onlyConservazione: item.canUseConservazione && !item.canUseFatturaPA,
              isCancellationInProgress: item.subscription.cancellationRequest,
              archisync: item.canUseArchiSync,
              archipro: item.canUseArchiPro,
              reseller: item.reseller
            } as IUserT;

            return newObj;
          }).sort((a, b) => {
            return a.company_name.localeCompare(b.company_name);
          });
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getUsersTypeaheadValues();

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.startSearch = () => {
      $scope.scaduti = allScaduti.filter(item => {
        const expired = new Date(item.subscriptionEndDate).getTime() <= ($scope.filtroScadenza[1] ? ($scope.filtroScadenza[1] as Date).getTime() : Infinity) &&
          new Date(item.subscriptionEndDate).getTime() >= ($scope.filtroScadenza[0] ? ($scope.filtroScadenza[0] as Date).getTime() : 0);
        // if(expired) console.log(item.subscriptionEndDate, $scope.filtroScadenza[1]);
        const company_name = item.company_name.toLowerCase().includes($scope.filtroScadenza[2] && ($scope.filtroScadenza[2] as string).toLowerCase() || '');
        const piva = item.piva.toLowerCase().includes($scope.filtroScadenza[3] && ($scope.filtroScadenza[3] as string).toLowerCase() || '');
        const codice_fiscale = item.codice_fiscale.toLowerCase().includes($scope.filtroScadenza[8] && ($scope.filtroScadenza[8] as string).toLowerCase() || '');
        const email = item.email.toLowerCase().includes($scope.filtroScadenza[4] && ($scope.filtroScadenza[4] as string).toLowerCase() || '');
        const codiceAttivazione = item.activationCode.toLowerCase().includes($scope.filtroScadenza[5] && ($scope.filtroScadenza[5] as string).toLowerCase() || '');

        const [giorno, mese, anno, ...resto] = item.activation.split('/');
        // console.log(item.activation, $scope.filtroScadenza[6], new Date(Number(anno),Number(mese)-1,Number(giorno)), new Date(item.activation).getTime() < ($scope.filtroScadenza[6] && $scope.filtroScadenza[6][1] || Infinity));
        const dataAttivazione = new Date(Number(anno), Number(mese) - 1, Number(giorno)).getTime() > ($scope.filtroScadenza[6] && $scope.filtroScadenza[6][0] || 0) && new Date(Number(anno), Number(mese) - 1, Number(giorno)).getTime() < ($scope.filtroScadenza[6] && $scope.filtroScadenza[6][1] || Infinity);
        // se attivo flag soloscaduti allora metti solo scaduti altrimenti metti tutti
        const soloScaduti = $scope.filtroScadenza[7] ? item.expired : true;
        // se attivo metti solo quelli che usano la firma
        const digitalsignature = $scope.filtroScadenza[9] ? item.useDigitalSign : true;
        const viewOnly = $scope.filtroScadenza[10] ? item.viewOnly : true;
        const onlyCons = $scope.filtroScadenza[13] ? item.onlyConservazione : true;
        const archisync = $scope.filtroScadenza[11] ? item.archisync : true;
        const archipro = $scope.filtroScadenza[11] ? item.archipro : true;
        const cancellationInProgress = $scope.filtroScadenza[14] ? item.isCancellationInProgress : true;

        let codice = item.activationCode.split('-')[1]; // default cerca partner sulla seconda cinquina

        if ($scope.filtroScadenza[12] && ($scope.filtroScadenza[12] as IListini).code.includes('-')) {
          const [primac, secondac, ...resto] = item.activationCode.split('-');
          codice = `${primac}-${secondac}`;
        }
        const partner = $scope.filtroScadenza[12] ? codice === ($scope.filtroScadenza[12] as IRivenditore).code || item.reseller && item.reseller._id === ($scope.filtroScadenza[12] as IRivenditore)._id : true;

        return expired && company_name && piva && codice_fiscale && email && dataAttivazione && codiceAttivazione && soloScaduti && digitalsignature && viewOnly && onlyCons && archisync && archipro && partner && cancellationInProgress;
      });
    };

    $scope.exportCsv = (yearToExport) => {

      $uibModal.open({
        animation: true,
        component: 'workerDownloadCsvClientiModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: {
            idList: $scope.scaduti.map((item => item._id)),
            user: $rootScope.currentUser().sub,
            year: yearToExport,
            key: 'yearToExport'
          }
        }
      });
    };

  }

  modifica(item: IUserT) {
    localStorage.setItem('mod_cli_email', item.email);
    this.$state.go('home.modifica-cliente');
  }

  checkDocArchive(item: IUserT) {
    this.$state.go('home.verifica-stato-conservazione', {userId: item._id});
  }
}

export const SchedaClientiComponent: ng.IComponentOptions = {
  template: require('./scheda-clienti.html'),
  controller: SchedaClientiController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/scheda-clienti/scheda-clienti.ts